// Tailwind
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from './../../tailwind.config.js';
const fullConfig = resolveConfig(tailwindConfig);

// Axios
import axios from 'axios';
import addOAuthInterceptor from 'axios-oauth-1.0a';
// Create a client whose requests will be signed
const client = axios.create();

// Specify the OAuth options
const options = {
  algorithm: 'HMAC-SHA1',
  key: 'ck_a039d3149686cf2b5c0e3dfa68b43cb9a5ea4904',
  secret: 'cs_c8bb092cb3ae2d460c9465025a691617b9fca0d9',
};

// Add interceptor that signs requests
addOAuthInterceptor(client, options);

// GSAP
import { gsap, ScrollTrigger, ScrollToPlugin } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const state = {
  fullConfig,
  openDropdown: {
    status: false,
    id: '',
  },
  bgColourImg: [
    {
      title: 'Belt',
      img: 'pages/home/gapless-grid/1.png',
    },
    {
      title: 'Keys Holder',
      img: 'pages/home/gapless-grid/2.png',
    },
    {
      title: 'Cards Holder',
      img: 'pages/home/gapless-grid/3.png',
    },
    {
      title: 'Casual Belts',
      img: 'pages/home/gapless-grid/4.png',
    },
    {
      title: 'Bifold Wallets',
      img: 'pages/home/gapless-grid/5.png',
    },
    {
      title: 'Informal Belts',
      img: 'pages/home/gapless-grid/6.png',
    },
  ],
  axiosWc: client,
  globals: {
    urlApi: 'https://milanoleather.azurewebsites.net/wp-json',
    tl: gsap.timeline({
      defaults: {
        duration: 0.75,
        stagger: 0.5,
      },
    }),
    title: 'Milano Leather',
    genuineLeather: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 170.123 211.019"><defs><style>.a{fill:none;stroke:#000;stroke-width:5px;}</style></defs><g transform="translate(2.158 2.22)"><path class="a" d="M118.422,24.15a52.934,52.934,0,0,1,8.108.743,9.747,9.747,0,0,1,7.259,4.587c2.164,3.069,11.222,18.156,30.469,20.272a73.384,73.384,0,0,0,18.964,0,4.65,4.65,0,0,1,4.179,1.615,58.3,58.3,0,0,1,8.491,11.759,5.546,5.546,0,0,1-.366,3.86c-.383,1.211-16.9,47.876-15.518,67.114,1.365,13.487,4,36.5,19.663,58.408,2.065,3.86,1.765,5.023-.616,8.529a69.431,69.431,0,0,1-10.689,13.229c-2.5,1.5-4.063,1.615-5.778.921s-24.309-11.63-48.767,5.621l-10.573,8.076a5.008,5.008,0,0,1-4.8,1,5.111,5.111,0,0,1-4.8-1l-10.573-8.076c-24.492-17.251-47.053-6.3-48.717-5.621s-3.33.581-5.777-.921A70.745,70.745,0,0,1,37.9,201.037c-2.364-3.505-2.681-4.668-.616-8.529,15.668-21.9,18.315-44.92,19.68-58.408,1.365-19.238-15.135-65.9-15.534-67.114a5.546,5.546,0,0,1-.383-3.86,58.274,58.274,0,0,1,8.408-11.759,4.649,4.649,0,0,1,4.179-1.615,73.384,73.384,0,0,0,19.047,0c19.231-2.116,28.3-17.2,30.469-20.272a9.747,9.747,0,0,1,7.243-4.587A53.156,53.156,0,0,1,118.422,24.15Z" transform="translate(-35.58 -23.87)"/></g></svg>`,
    arrow: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 11 6" xml:space="preserve">
      <path class="st0" d="M5.4,4.4l4.5-4.2c0.2-0.3,0.7-0.3,0.9,0c0,0,0,0,0,0c0.3,0.3,0.3,0.7,0,1c0,0,0,0,0,0L5.9,5.8 C5.6,6.1,5.2,6.1,5,5.8L0.2,1.1c-0.3-0.3-0.3-0.7,0-0.9C0.4,0,0.8,0,1.1,0.2c0,0,0,0,0,0L5.4,4.4z"></path>
    </svg>`,
    brandsSVG: {
      force: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 102.87"><defs><style>.a,.b{fill:#fff;}.b{fill-rule:evenodd;}</style></defs><g transform="translate(44.964 11.773)"><path class="a" d="M147.351,55.628A43.646,43.646,0,0,0,136.5,33.274c-21.929-13.9-32.473,20.015-32.473,20.015l-.6,2.339Z" transform="translate(-103.42 -29.93)"/></g><g transform="translate(27.8 46.321)"><path class="a" d="M80.538,106.85,65.85,163.4l13.409-13.08c36.63.457,45.639-29.595,45.639-29.595a50.19,50.19,0,0,0,2.627-13.865Z" transform="translate(-65.85 -106.85)"/></g><g transform="translate(0 0)"><path class="a" d="M14.923,51.074l2.668-9.443h11.59C44.714,4.169,68.47,8.084,69.489,8.24A45.632,45.632,0,0,0,5,49.347a44.875,44.875,0,0,0,13.989,32.56,185.939,185.939,0,0,1,6.739-30.833Z" transform="translate(-5 -4.16)"/></g><g transform="translate(98.132 33.66)"><path class="b" d="M282.108,78.59H232.2A10.887,10.887,0,0,0,221.31,89.477v22.98A10.887,10.887,0,0,0,232.2,123.343h49.907A10.887,10.887,0,0,0,293,112.456V89.477A10.887,10.887,0,0,0,282.108,78.59m-.48,29.5c0,3.728-3.3,6.752-7.374,6.752H240.448c-4.066,0-7.369-3.024-7.369-6.752V93.853c0-3.728,3.3-6.752,7.369-6.752h33.807c4.071,0,7.374,3.024,7.374,6.752Z" transform="translate(-221.31 -78.59)"/></g><g transform="translate(177.999 33.655)"><path class="b" d="M456.479,106.577h1.827a10.9,10.9,0,0,0,10.9-10.9v-6.2A10.891,10.891,0,0,0,458.32,78.59H397.39v44.771h11.243V87.193h47.079a4.685,4.685,0,0,1,4.833,4.514v2.572a4.679,4.679,0,0,1-4.833,4.514H414.979v8.141H440.22l17.621,17.123h14.912Z" transform="translate(-397.39 -78.59)"/></g><g transform="translate(260.062 33.66)"><path class="b" d="M643.226,114.869H596.234a6.707,6.707,0,0,1-6.72-6.716V93.99a6.707,6.707,0,0,1,6.7-6.711h47.01V78.718a11.562,11.562,0,0,0-1.6-.128H589.057A10.891,10.891,0,0,0,578.17,89.481v22.975a10.887,10.887,0,0,0,10.887,10.887h52.538a10.306,10.306,0,0,0,1.6-.132Z" transform="translate(-578.17 -78.59)"/></g><g transform="translate(334.935 33.66)"><path class="b" d="M808.255,114.869h-47a6.711,6.711,0,0,1-6.706-6.711V94a6.706,6.706,0,0,1,6.706-6.711h47V78.718a11.553,11.553,0,0,0-1.6-.128H754.068A10.887,10.887,0,0,0,743.19,89.481v22.975a10.882,10.882,0,0,0,10.878,10.887h52.588a10.3,10.3,0,0,0,1.6-.132Z" transform="translate(-743.19 -78.59)"/></g><g transform="translate(353.932 51.404)"><rect class="a" width="44.95" height="8.612"/></g></svg>`,
    },
    drawer: false,
    mainMenu: [
      {
        title: 'Brands',
        showTitle: true,
        url: '#',
        class: 'flex items-center',
        img: '',
        imgClass: '',
        hasChildren: true,
      },
      {
        title: 'Contact us',
        showTitle: true,
        url: '/contact/',
        img: '',
        imgClass: '',
        hasChildren: false,
      },
      {
        title: 'About us',
        showTitle: true,
        url: '/about/',
        img: '',
        imgClass: '',
        hasChildren: false,
      },
      {
        title: 'Shop',
        showTitle: true,
        url: 'http://shop.milanoleather.ae/shop/',
        img: '',
        imgClass: '',
        hasChildren: false,
      },
    ],
    footer: {
      'socialMedia': {
        'amazon': {
          'title': 'Amazon',
          'url': 'https://www.amazon.ae/MilanoLeatherAE',
          'icon': 'mdi-amazon',
        },
        'facebook': {
          'title': 'Facebook',
          'url': 'https://www.facebook.com/MilanoLeatherAE',
          'icon': 'mdi-facebook',
        },
        'instagram': {
          'title': 'Instagram',
          'url': 'https://www.instagram.com/MilanoLeatherAE',
          'icon': 'mdi-instagram',
        },
        'pinterest': {
          'title': 'Pinterest',
          'url': 'https://www.pinterest.com/MilanoLeatherAE',
          'icon': 'mdi-pinterest',
        },
        'twitter': {
          'title': 'Twitter',
          'url': 'https://twitter.com/MilanoLeatherAE',
          'icon': 'mdi-twitter',
        },
        'email': {
          'title': 'Email',
          'url': 'mailto:kkat.cliff@gmail.com',
          'icon': 'mdi-email',
        },
        'phone': {
          'title': '+971 55 20 26 291',
          'url': 'tel:+971552026291',
          'icon': 'mdi-phone',
        },
      },
    },
  },
  pages: {
    home: {
      mainImg: {
        src: 'pages/home/main.jpg',
        alt: 'Milano Leather',
        caption: 'Quality Leather Products<br/>for Generations to Come',
        ctaUrl: '//shop.milanoleather.ae/shop/',
        ctaTitle: 'Shop now',
      },
      brands: [],
      gridTwoCol: [
        {
          id: 1,
          title: 'First',
          img: '',
          text: `<span class="heading mb-5 py-5 sm:py-3 text-xl sm:text-lg md:text-xl lg:text-3xl text-mlt-yellow">A stitch in time &mdash; A rich heritage</span><span class="caption px-10 sm:text-xs md:text-sm lg:text-lg text-center">A world where luxury and versatility are never compromised. Where our expertise meets your individuality. A world where our craft meets your story.</span>`,
        },
        {
          id: 2,
          title: 'Second',
          img: 'pages/home/grid-col-two/3.png',
        },
        {
          id: 3,
          title: 'Third',
          img: 'pages/home/grid-col-two/3.png',
        },
        {
          id: 4,
          title: 'Fourth',
          img: 'pages/home/grid-col-two/4.png',
        },
      ],
      plainImg: [
        {
          title: 'Blue Belt',
          img: 'pages/home/plain-grid/1.png',
        },
        {
          title: 'Brown Bag',
          img: 'pages/home/plain-grid/2.png',
        },
        {
          title: 'Pink Belt',
          img: 'pages/home/plain-grid/3.png',
        },
        {
          title: 'New 1',
          img: 'pages/home/plain-grid/4.png',
        },
        {
          title: 'New 2',
          img: 'pages/home/plain-grid/5.png',
        },
        {
          title: 'New 3',
          img: 'pages/home/plain-grid/6.png',
        },
      ],
    },
    focus: {
      varietyTabs: [],
    },
    force: {
      mainImg: {
        width: '50',
        height: 'auto',
        responsive: {
          'sm': {
            width: '',
          },
          'md': {
            width: '',
          },
          'lg': {
            width: '135',
          },
        },
        watermark: true,
        // ,{
        // 	src: 'pages/brands/force/watermark.png',
        // 	bottom: '50px',
        // 	left: '50px',
        // 	responsive: {
        // 		'sm': {
        // 			bottom: '',
        // 			left: '',
        // 		},
        // 		'md': {
        // 			bottom: '',
        // 			left: '',
        // 		},
        // 		'lg': {
        // 			bottom: '',
        // 			left: '',
        // 		},
        // 	},
        // },
        src: {
          webp: 'pages/brands/force/main.webp',
          jpg: 'pages/brands/force/main.jpg',
        },
        alt: 'Brand | Force',
        caption: 'Leather Products<br/>for the Next Generation',
        ctaUrl: '#',
        ctaTitle: 'Shop now',
      },
      varietyTabs: [
        {
          id: 'gents-wallets',
          title: 'Gents Wallets',
          img: 'pages/brands/force/variety-tabs/1.jpg',
          url: '#',
          content: [
            {
              id: 1100000,
              title: 'Gents Wallet 1',
              img: 'pages/brands/force/variety-tabs/1-1-IMG_3001.png',
              url: '/product/force/gents-wallets/1100000',
              colours: {
                '#000': 'Black',
                '#F00': 'Red',
                '#0F0': 'Green',
                '#00F': 'Blue',
              },
              sizes: {
                'SM': 'Small',
                'MD': 'Medium',
                'LG': 'Large',
                'XL': 'X-large',
              },
            },
            {
              id: 1200000,
              title: 'Gents Wallet 2',
              img: 'pages/brands/force/variety-tabs/1-2-IMG_3001.png',
              url: '/product/force/gents-wallets/1200000',
              colours: {
                '#000': 'Black',
                '#F00': 'Red',
                '#0F0': 'Green',
                '#00F': 'Blue',
              },
              sizes: {
                'SM': 'Small',
                'MD': 'Medium',
                'LG': 'Large',
                'XL': 'X-large',
              },
            },
            {
              id: 1300000,
              title: 'Gents Wallet 3',
              img: 'pages/brands/force/variety-tabs/1-3-IMG_3001.png',
              url: '/product/force/gents-wallets/1300000',
              colours: {
                '#000': 'Black',
                '#F00': 'Red',
                '#0F0': 'Green',
                '#00F': 'Blue',
              },
              sizes: {
                'SM': 'Small',
                'MD': 'Medium',
                'LG': 'Large',
                'XL': 'X-large',
              },
            },
          ],
        },
        {
          id: 'ladies-wallets',
          title: 'Ladies Wallets',
          img: 'pages/brands/force/variety-tabs/2.png',
          url: '#',
          content: [
            {
              id: 2100000,
              title: 'Ladies Wallet 1',
              img: 'pages/brands/force/variety-tabs/2-1-IMG_3001.png',
              url: '',
              colours: {
                '#000': 'Black',
                '#F00': 'Red',
                '#0F0': 'Green',
                '#00F': 'Blue',
              },
            },
            {
              id: 2200000,
              title: 'Ladies Wallet 2',
              img: 'pages/brands/force/variety-tabs/2-2-IMG_3001.png',
              url: '',
              colours: {
                '#000': 'Black',
                '#F00': 'Red',
                '#0F0': 'Green',
                '#00F': 'Blue',
              },
            },
          ],
        },
        {
          id: 'belts',
          title: 'Belts',
          img: 'pages/brands/force/variety-tabs/3.png',
          url: '#',
          content: [
            {
              id: 3100000,
              title: 'Belt 1',
              img: {
                'main': 'pages/brands/force/variety-tabs/belts/img_4850.png',
                1: 'pages/brands/force/variety-tabs/belts/img_4654.jpg',
                2: 'pages/brands/force/variety-tabs/belts/img_4649.jpg',
                3: 'pages/brands/force/variety-tabs/belts/img_4657.jpg',
                4: 'pages/brands/force/variety-tabs/belts/img_4662.jpg',
              },
              url: '/product/force/belts/3100000',
              colours: {
                '000': 'Black',
                br: 'Brown',
                tn: 'Tan',
              },
              sizes: {
                sm: '28'
              },
            },
            {
              id: 3200000,
              title: 'Belt 2',
              img: 'pages/brands/force/variety-tabs/3-2-IMG_3001.png',
              url: '/product/force/belts/3100000',
            },
            {
              id: 3300000,
              title: 'Belt 3',
              img: 'pages/brands/force/variety-tabs/3-3-IMG_3001.png',
              url: '',
            },
            {
              id: 3400000,
              title: 'Belt 4',
              img: 'pages/brands/force/variety-tabs/3-4-IMG_3001.png',
              url: '/product/force/belts/3100000',
            },
            {
              id: 3500000,
              title: 'Belt 5',
              img: 'pages/brands/force/variety-tabs/3-5-IMG_3001.png',
              url: '/product/force/belts/3100000',
            },
            {
              id: 3600000,
              title: 'Belt 6',
              img: 'pages/brands/force/variety-tabs/3-6-IMG_3001.png',
              url: '/product/force/belts/3100000',
            },
            {
              id: 3700000,
              title: 'Belt 7',
              img: 'pages/brands/force/variety-tabs/3-7-IMG_3001.png',
              url: '/product/force/belts/3100000',
            },
            {
              id: 3800000,
              title: 'Belt 8',
              img: 'pages/brands/force/variety-tabs/3-8-IMG_3001.png',
              url: '',
            },
          ],
        },
        {
          id: 'card-holders',
          title: 'Card Holders',
          img: 'pages/brands/force/variety-tabs/4.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Card Holder 1',
              img: 'pages/brands/force/variety-tabs/4-1-IMG_3001.png',
              url: '',
            },
            {
              id: 2,
              title: 'Card Holder 2',
              img: 'pages/brands/force/variety-tabs/4-2-IMG_3001.png',
              url: '',
            },
          ],
        },
        {
          id: 'keychains',
          title: 'Keychains',
          img: 'pages/brands/force/variety-tabs/5.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Keychain 1',
              img: 'pages/brands/force/variety-tabs/5-1-IMG_3001.png',
              url: '',
            },
          ],
        },
        {
          id: 'card-cases',
          title: 'Card Cases',
          img: 'pages/brands/force/variety-tabs/6.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Card Case 1',
              img: 'pages/brands/force/variety-tabs/6-1-IMG_3001.png',
              url: '',
            },
          ],
        },
        {
          id: 'money-clips',
          title: 'Money Clips',
          img: 'pages/brands/force/variety-tabs/7.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Money Clip 1',
              img: 'pages/brands/force/variety-tabs/7-1-IMG_3001.png',
              url: '',
            },
          ],
        },
        {
          id: 'bags',
          title: 'Bags',
          img: 'pages/brands/force/variety-tabs/8.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Money Clip 1',
              img: 'pages/brands/force/variety-tabs/7-1-IMG_3001.png',
              url: '',
            },
          ],
        },
        {
          id: 'passport-holders',
          title: 'Passport Holders',
          img: 'pages/brands/force/variety-tabs/9.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Money Clip 1',
              img: 'pages/brands/force/variety-tabs/6-1-IMG_3001.png',
              url: '',
            },
          ],
        },
      ],
      swatchCopyProduct: {
        container: {
          classes: ['swatch-copy-product','relative','grid grid-rows-6 md:grid-rows-1 grid-cols-6 md:grid-cols-12',],
          columns: [
            {
              container: {
                classes: ['brand','relative w-full h-full','row-start-1 row-end-3 col-span-12 md:col-span-4','flex flex-col lg:flex-row justify-center items-center'],
                content: [
                  {
                    classes: ['brand-img','absolute md:relative bottom-0 md:bottom-auto pb-24 md:pb-0',],
                    img: {
                      src: 'brands/logo-brand-force.svg',
                      alt: 'Logo: Brand | Force',
                      width: 200,
                      height: 'auto',
                    },
                  }, {
                    classes: ['logo-genuine-leather','absolute flex flex-col justify-end md:justify-center md:items-end lg:self-center',],
                    img: {
                      src: 'logo-genuine-leather.svg',
                      width: 125,
                      height: 'auto',
                    },
                    style: {
                      // responsive: {
                      // 	xs: {
                      // 		right: 'initial',
                      // 		bottom: '-75px', // XS: Half of height
                      // 	},
                      // 	md: {
                      // 		right: '-62px', // MD: Half of width
                      // 	},
                      // },
                    },
                  },
                  {
                    classes: 'sm:hidden p-2 rounded-lg bg-black bg-opacity-25',
                    text: `We put our heart & soul alongside endless design hours<br> into helping people carry a signature of simplicity and ease.<br> We carefully put in every piece<br> and deeply regard the best quality as a sign of success.<br> The result of that success is our brand...`,
                    style: {
                      color: '#fff',
                      textAlign: 'center',
                    },
                  },
                ],
                style: {
                  backgroundImage: `url(${require('@/img/pages/brands/force/swatch-copy-product/1-creative-belt-IMG_2583.png')})`,
                  // left: '0%',
                  // background: `right / cover no-repeat url(${require('@/img/pages/brands/force/swatch-copy-product/1-creative-belt-IMG_2583.png')})`,
                  // minHeight: '30rem',
                },
              },
            }, {
              container: {
                classes: [
                  'row-start-3 row-end-7 md:row-start-1 md:row-span-1 col-span-8 md:h-full',
                  'grid grid-cols-12 items-center',
                  'text-xl text-center',
                ],
                content: {
                  classes: [
                    'col-start-1 col-span-12',
                    'md:col-end-6',
                    'lg:col-start-3',
                    'h-full md:h-auto pt-24 md:pt-0'
                  ],
                  text: `
                    The brand "Force"
                    <br class="sm:hidden md:block">
                    <br class="sm:hidden md:block">
                    <span class="hidden sm:inline md:hidden">&nbsp;</span>
                    is a culmination of
                    <span class="hidden sm:inline md:hidden">&nbsp;</span>
                    <br class="sm:hidden md:block">
                    <br class="sm:hidden md:block">
                    years of expertise, and
                    <span class="hidden sm:inline md:hidden">&nbsp;</span>
                    <br class="sm:hidden md:block">
                    <br class="sm:hidden md:block">
                    an innovative vision.
                  `
                },
                style: {
                  backgroundImage: `url(${require('@/img/pages/brands/force/swatch-copy-product/2-creative-belt-IMG_2351.png')})`,
                  // responsive: {
                  // 	md: {
                  // 	},
                  // 	xs: {
                  // 		background: `right bottom / contain no-repeat url(${require('@/img/pages/brands/force/swatch-copy-product/2-creative-belt-IMG_2351.png')})`,
                  // 	}
                  // }
                },
              },
            }
          ],
        },
      }
    },
    'classic-milano': {
      mainImg: {
        width: '150',
        height: 'auto',
        responsive: {
          'sm': {
            width: '',
          },
          'md': {
            width: '300',
            height: 'auto',
          },
          'lg': {},
          'xl': {},
        },
        watermark: {
          src: 'pages/brands/classic-milano/watermark.png',
          right: '25px',
          bottom: '25px',
          responsive: {
            'sm': {},
            'md': {
              right: '50px',
              bottom: '50px',
            },
            'lg': {},
            'xl': {},
          },
        },
        src: {
          webp: 'pages/brands/classic-milano/main.webp',
          jpg: 'pages/brands/classic-milano/main.jpg',
        },
        alt: 'Brand | Classic Milano',
        caption: 'Leather Products<br/>for the Next Generations',
        ctaUrl: '#',
        ctaTitle: 'Shop now',
      },
      varietyTabs: [
        {
          id: 1,
          title: 'Gents Wallets',
          img: 'pages/brands/classic-milano/variety-tabs/1-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Gents Wallet 1',
              img: 'pages/brands/classic-milano/variety-tabs/1-1-IMG_3001.png',
              url: '#',
            },
            {
              id: 2,
              title: 'Gents Wallet 2',
              img: 'pages/brands/classic-milano/variety-tabs/1-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 2,
          title: 'Ladies Wallets',
          img: 'pages/brands/classic-milano/variety-tabs/2-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Ladies Wallet 1',
              img: 'pages/brands/classic-milano/variety-tabs/2-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 3,
          title: 'Belts',
          img: 'pages/brands/classic-milano/variety-tabs/3-Intersection 1.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Belt 1',
              img: 'pages/brands/classic-milano/variety-tabs/3-1-IMG_3001.png',
              url: '#',
            },
            {
              id: 2,
              title: 'Belt 2',
              img: 'pages/brands/classic-milano/variety-tabs/3-2-IMG_3001.png',
              url: '#',
            },
            {
              id: 3,
              title: 'Belt 3',
              img: 'pages/brands/classic-milano/variety-tabs/3-3-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 4,
          title: 'Card Holders',
          img: 'pages/brands/classic-milano/variety-tabs/4-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Card Holder 1',
              img: 'pages/brands/classic-milano/variety-tabs/4-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 5,
          title: 'Keychain',
          img: 'pages/brands/classic-milano/variety-tabs/5-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Keychain 1',
              img: 'pages/brands/classic-milano/variety-tabs/5-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 6,
          title: 'Card Cases',
          img: 'pages/brands/classic-milano/variety-tabs/6-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Card Case 1',
              img: 'pages/brands/classic-milano/variety-tabs/6-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 7,
          title: 'Money Clips',
          img: 'pages/brands/classic-milano/variety-tabs/7-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Money Clip 1',
              img: 'pages/brands/classic-milano/variety-tabs/7-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 8,
          title: 'Bags',
          img: 'pages/brands/classic-milano/variety-tabs/8-IMG_0442.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Bag 1',
              img: 'pages/brands/classic-milano/variety-tabs/8-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 9,
          title: 'Passport Holders',
          img: 'pages/brands/classic-milano/variety-tabs/9-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Passport Holder 1',
              img: 'pages/brands/classic-milano/variety-tabs/9-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
      ],
      swatchCopyProduct: {
        container: {
          classes: ['swatch-copy-product','relative','grid grid-rows-2 md:grid-rows-1 grid-cols-12',],
          columns: [
            {
              container: {
                classes: [
                  'brand',
                  'absolute w-full h-full',
                  'row-start-1 row-span-2 row-end-2',
                  'col-start-1 col-span-12 md:col-span-6',
                  'flex flex-col justify-center items-end',
                ],
                content: [
                  {
                    classes: [
                      'relative brand-logo',
                      'flex flex-row justify-end items-center'
                    ],
                    img: {
                      src: 'brands/logo-brand-classic-milano.svg',
                      alt: '',
                      width: 175,
                      height: 'auto',
                    },
                    style: {
                      top: '0.5rem',
                      right: '1rem',
                    }
                  }, {
                    classes: ['logo-genuine-leather','absolute sm:h-full md:h-auto flex flex-col justify-end lg:justify-start',],
                    img: {
                      src: 'logo-genuine-leather.svg',
                      width: 85,
                      height: 'auto',
                      responsive: [
                        {
                          md: {
                            width: 125,
                            height: 'auto',
                          },
                        },
                      ],
                    },
                    style: {
                      right: '-40px', // Should be half of width
                      bottom: '1rem',
                      responsive: [
                        {
                          md: {
                            right: '-62px', // Half of width
                            bottom: '1rem',
                          },
                        }
                      ],
                    },
                  },
                ],
                style: {
                  position: 'relative',
                  minHeight: '30rem',
                  left: '0%',
                  background: `right / cover no-repeat url(${require('@/img/pages/brands/classic-milano/swatch-copy-product/swatch-IMG_2581.png')})`,
                }
              }
            },
            {
              container: {
                classes: [
                  'relative',
                  'row-start-2 row-span-1 row-end-3',
                  'md:row-start-1 md:row-end-1',
                  'lg:row-start-1',
                  'col-span-12 md:col-span-6 md:h-full',
                  'grid grid-cols-12 justify-center',
                ],
                content: {
                  classes: [
                    'absolute copy text-xl text-left',
                    'col-start-3 col-end-12'
                  ],
                  text: `Instilling the traditional<br><br>value and skilled craftsmanship<br><br>the "<span class="text-mlt-brown font-bold">Classic Milano</span>" line<br><br>paves its way for the modern world.`,
                  style: {
                    top: '3rem',
                  }
                },
                style: {
                  backgroundImage: `url(${require('@/img/pages/brands/classic-milano/swatch-copy-product/3-IMG_3001.png')})`,
                },
              }
            },
          ],
        },
      },
    },
    cliff: {
      mainImg: {
        width: '200',
        height: 'auto',
        watermark: {
          src: 'pages/brands/cliff/watermark.png',
          bottom: '3rem',
          left: '3rem',
        },
        src: 'pages/brands/cliff/main.jpg',
        alt: 'Brand | Cliff',
        caption: 'Casual Leather Products<br/>for the Next Generations',
        ctaUrl: '#',
        ctaTitle: 'Shop now',
      },
      varietyTabs: [
        {
          id: 1,
          title: 'Gents Wallets',
          img: 'pages/brands/cliff/variety-tabs/1-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Gents Wallet 1',
              img: 'pages/brands/cliff/variety-tabs/1-1-IMG_3001.png',
              url: '#',
            },
            {
              id: 2,
              title: 'Gents Wallet 2',
              img: 'pages/brands/cliff/variety-tabs/1-2-IMG_3001.png',
              url: '#',
            },
            {
              id: 3,
              title: 'Gents Wallet 3',
              img: 'pages/brands/cliff/variety-tabs/1-3-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 2,
          title: 'Ladies Wallets',
          img: 'pages/brands/cliff/variety-tabs/2-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Ladies Wallet 1',
              img: 'pages/brands/cliff/variety-tabs/2-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 3,
          title: 'Belts',
          img: 'pages/brands/cliff/variety-tabs/3-Intersection 1.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Belt 1',
              img: 'pages/brands/cliff/variety-tabs/3-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 4,
          title: 'Card Holders',
          img: 'pages/brands/cliff/variety-tabs/4-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Card Holder 1',
              img: 'pages/brands/cliff/variety-tabs/4-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 5,
          title: 'Keychains',
          img: 'pages/brands/cliff/variety-tabs/5-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Keychain 1',
              img: 'pages/brands/cliff/variety-tabs/5-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 6,
          title: 'Card Cases',
          img: 'pages/brands/cliff/variety-tabs/6-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Card Case 1',
              img: 'pages/brands/cliff/variety-tabs/6-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 7,
          title: 'Money Clips',
          img: 'pages/brands/cliff/variety-tabs/7-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Money Clip 1',
              img: 'pages/brands/cliff/variety-tabs/7-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
        {
          id: 8,
          title: 'Passport Holders',
          img: 'pages/brands/cliff/variety-tabs/8-Intersection 2.png',
          url: '#',
          content: [
            {
              id: 1,
              title: 'Passport Holder 1',
              img: 'pages/brands/cliff/variety-tabs/7-1-IMG_3001.png',
              url: '#',
            },
          ],
        },
      ],
      swatchCopyProduct: {
        container: {
          classes: [
            'swatch-copy-product',
            'relative',
            'grid grid-rows-2 md:grid-rows-1 grid-cols-12'
          ],
          columns: [
            {
              container: {
                classes: [
                  'brand',
                  'absolute w-full h-full',
                  'row-start-1 row-span-1 row-end-2',
                  'col-start-1 col-span-12 md:col-span-8',
                  'flex flex-col justify-center items-center',
                ],
                content: [
                  {
                    classes: ['absolute brand-logo'],
                    img: {
                      src: 'brands/logo-brand-cliff.svg',
                      alt: 'Logo: Brand | Cliff',
                      width: 100,
                      height: 'auto',
                      responsive: [
                        {
                          md: {
                            width: 200,
                            height: 'auto',
                          },
                        },
                      ],
                    },
                    style: {
                      right: '2rem',
                      bottom: '2rem',
                    }
                  },
                  {
                    classes: ['logo-genuine-leather','absolute flex flex-col justify-center'],
                    img: {
                      src: 'logo-genuine-leather.svg',
                      width: 125,
                      height: 'auto',
                    },
                    style: {
                      top: '3rem',
                      right: '-62px',
                    }
                  },
                  {
                    text: `
                      Cliff Leather Fashion<br> is a major manufacturer and exporter of leather goods<br> and accessories.<br> Our range represents a perfect blend of craftsmanship innovation.
                    `,
                    style: {
                      'color': '#ca9f74',
                      'text-align': 'center'
                    }
                  },
                ],
                style: {
                  position: 'relative',
                  left: '0',
                  backgroundImage: `url(${require('@/img/pages/brands/cliff/swatch-copy-product/1-IMG_2612.png')})`,
                  minHeight: '30rem',
                }
              }
            }, {
              container: {
                classes: [
                  'row-start-2 row-span-1 row-end-3',
                  'md:row-start-1 md:row-end-1',
                  'col-span-12 md:col-span-4 relative',
                  'grid grid-cols-12 items-start',
                  'text-xl text-center',
                ],
                content: [
                  {
                    classes: [
                      'col-start-5 col-end-10',
                      'md:col-start-3 md:col-end-11',
                      'absolute copy-1',
                      'text-xs md:text-base',
                    ],
                    text: `Everyday style with a touch of luxury, stay ahead with our new PU wallets`,
                    style: {
                      gridRowStart: 2,
                    }
                  },
                  {
                    classes: [
                      'col-start-5 col-end-10',
                      'md:col-start-3 md:col-end-11',
                      'absolute copy-2',
                      'text-xs md:text-base',
                    ],
                    text: `Find the perfect accessory for you in our new season collection`,
                    style: {
                      gridRowStart: 5,
                    }
                  }
                ],
                style: {
                  background: `center center / 60% no-repeat url(${require('@/img/pages/brands/cliff/swatch-copy-product/2-IMG_3063.png')})`,
                }
              }
            }
          ],
        }
      },
    },
    about: {
      mainImg: {
        width: '200',
        height: 'auto',
        // watermark: {
        // 	src: 'pages/brands/cliff/watermark.png',
        // 	bottom: '50px',
        // },
        src: 'pages/about/main.jpg',
        alt: 'About',
        caption: `<span class="rounded bg-opacity-75 bg-orange-500">Service that spans generations</span>`,
        ctaUrl: '#',
        ctaTitle: 'Shop now',
      },
    },
    product: {
      loading: true,
      active: {
        colour: '000'
      },
      properties: {},
    },
    brand: {
      tabs: null,
      tabContent: null,
    },
  },
};

export default state;
